import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import '../styles/Pages.css';

const getYouTubeId = (url) => {
  if (!url) return null;
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
};

const VideoPage = () => {
  const { settings } = useApp();
  const videos = settings.videos || [];
  const featuredId = settings.featuredVideoId || videos[0]?.id;
  const featured = videos.find(v => v.id === featuredId) || videos[0] || null;
  const archive = videos.filter(v => v.id !== featured?.id);

  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="page-container">
      <div className="page-content">
        <h2>Event Videos & Highlights</h2>

        {featured ? (
          <div className="info-section">
            <h3>📹 {featured.year} — {featured.title}</h3>
            <div className="video-container">
              <iframe
                width="100%"
                style={{ aspectRatio: '16/9', border: 'none', borderRadius: '8px', display: 'block' }}
                src={`https://www.youtube.com/embed/${getYouTubeId(featured.youtubeUrl)}`}
                title={featured.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        ) : (
          <div className="info-section">
            <p className="video-note">Videos will be added as the event approaches. Check back soon!</p>
          </div>
        )}

        {archive.length > 0 && (
          <div className="info-section">
            <h3>Previous Years</h3>
            <div className="video-archive-grid">
              {archive.map(v => {
                const ytId = getYouTubeId(v.youtubeUrl);
                const isExpanded = expandedId === v.id;
                return (
                  <div key={v.id} className="video-archive-item">
                    {isExpanded ? (
                      <div>
                        <iframe
                          width="100%"
                          style={{ aspectRatio: '16/9', border: 'none', borderRadius: '8px', display: 'block' }}
                          src={`https://www.youtube.com/embed/${ytId}?autoplay=1`}
                          title={v.title}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                        <button className="video-collapse-btn" onClick={() => setExpandedId(null)}>✕ Close</button>
                      </div>
                    ) : (
                      <div className="video-thumb-wrap" onClick={() => setExpandedId(v.id)}>
                        <div className="video-thumb-img-wrap">
                          <img
                            src={`https://img.youtube.com/vi/${ytId}/hqdefault.jpg`}
                            alt={v.title}
                            className="video-thumb"
                          />
                          <div className="video-thumb-overlay">
                            <div className="video-play-icon">▶</div>
                          </div>
                        </div>
                        <div className="video-thumb-info">
                          <span className="video-thumb-title">{v.title}</span>
                          <span className="video-thumb-year">{v.year}</span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPage;
